<template>
	<div class="page-wrapper">
		<!-- Header -->
		<Header />
		<!-- Header end -->
		<!-- Main -->
		<main class="site-content">
			<slot />
		</main>
		<!-- Main end -->
		<!-- Footer -->
		<Footer />
		<!-- Footer end -->
	</div>
</template>

<script setup>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import { onMounted, onUnmounted } from "vue";

const updatePadding = () => {
	const header = document.querySelector(".site-header");
	const content = document.querySelector(".site-content");

	if (header && content) {
		const headerHeight = header.offsetHeight;
		content.style.paddingTop = `${headerHeight}px`;
	}
};

const handleScroll = () => {
	const header = document.querySelector(".site-header .main-menu");
	if (header) {
		// Check if the vertical scroll position is greater than the header's height
		if (window.scrollY > 30) {
			header.classList.add("after-scroll");
		} else {
			header.classList.remove("after-scroll");
		}
	}
};

onMounted(() => {
	// Add event listeners for load and resize
	window.addEventListener("load", updatePadding);
	window.addEventListener("resize", updatePadding);
	window.addEventListener("scroll", handleScroll);

	// Trigger padding adjustment on initial load
	updatePadding();
});

onUnmounted(() => {
	// Clean up event listeners when the component is destroyed
	window.removeEventListener("load", updatePadding);
	window.removeEventListener("resize", updatePadding);
	window.removeEventListener("scroll", handleScroll);
});
</script>
